import { Esame } from './esame';
import { SchemaAgenda } from './agenda_utente';
import { Gravidanza } from './gravidanza';

import { Utente } from './utente';
import { HmModelRest } from './abstract_model';
import { MultiLangString } from './lingua_sistema';

export class SchemaPrestazione extends HmModelRest {

    static readonly rest_path = 'schemi_prestazione';

    id: number;
    schema_agenda: number | SchemaAgenda;
    esame: number;
    opzionale: boolean;
    nota: string;
    ordinamento: number;
    Esame: Esame;
    disabled: boolean;
}

export class Prestazione extends HmModelRest {
    static readonly rest_path = 'prestazioni';

    id: number;
    gravidanza: number | Gravidanza;
    agenda_utente: number;
    schema_agenda: number;
    schema_prestazione: number;
    esame: number;
    operatore_codice: string;
    operatore_codice_fiscale: string;
    operatore_denominazione: string;
    operatore_ruolo: string;
    validazione: boolean;
    tstamp_validazione: string;
}

export class Prescrizione extends HmModelRest {
    static readonly rest_path = 'prescrizioni';

    id: number;
    gravidanza: number | Gravidanza;
    agenda_utente: number;
    schema_agenda: number;
    esame: number;
    operatore_codice: string;
    operatore_codice_fiscale: string;
    operatore_denominazione: string;
    operatore_ruolo: string;
    validazione: boolean;
    tstamp_validazione: string;
    note_prescrizione: string;

    nre_code: string;
    nre_prefix: string;
    nre_prescrizione: string;
}